import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import Button from '../../wui-button/src';
import Icon from '../../wui-icon/src';
import PropTypes from 'prop-types';

function noop() {}

var propTypes = {
  className: PropTypes.string,
  leftArrowText: PropTypes.string,
  rightArrowText: PropTypes.string,
  moveToLeft: PropTypes.func,
  moveToRight: PropTypes.func,
  leftActive: PropTypes.boolean,
  rightActive: PropTypes.boolean
};
var defaultProps = {
  leftArrowText: '',
  rightArrowText: '',
  moveToLeft: noop,
  moveToRight: noop
};

var TransferOperation = /*#__PURE__*/function (_React$Component) {
  _inherits(TransferOperation, _React$Component);

  var _super = _createSuper(TransferOperation);

  function TransferOperation() {
    _classCallCheck(this, TransferOperation);

    return _super.apply(this, arguments);
  }

  _createClass(TransferOperation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          moveToLeft = _this$props.moveToLeft,
          moveToRight = _this$props.moveToRight,
          allMoveToLeft = _this$props.allMoveToLeft,
          allMoveToRight = _this$props.allMoveToRight,
          leftArrowText = _this$props.leftArrowText,
          rightArrowText = _this$props.rightArrowText,
          leftActive = _this$props.leftActive,
          rightActive = _this$props.rightActive,
          className = _this$props.className,
          renderOperation = _this$props.renderOperation;
      var allMoveToRightButton = /*#__PURE__*/React.createElement("button", {
        disabled: !leftActive,
        onClick: allMoveToRight
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
        type: "uf-2arrow-right"
      }), leftArrowText));
      var moveToLeftButton = /*#__PURE__*/React.createElement("button", {
        disabled: !leftActive,
        onClick: moveToLeft
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
        type: "uf-arrow-left"
      }), leftArrowText));
      var moveToRightButton = /*#__PURE__*/React.createElement("button", {
        disabled: !rightActive,
        onClick: moveToRight
      }, /*#__PURE__*/React.createElement("span", null, rightArrowText, /*#__PURE__*/React.createElement(Icon, {
        type: "uf-arrow-right"
      })));
      var allMoveToLeftButton = /*#__PURE__*/React.createElement("button", {
        disabled: !leftActive,
        onClick: allMoveToLeft
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
        type: "uf-2arrow-left"
      }), leftArrowText));
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, allMoveToRightButton, moveToLeftButton, moveToRightButton, allMoveToLeftButton, renderOperation());
    }
  }]);

  return TransferOperation;
}(React.Component);

TransferOperation.propsType = propTypes;
TransferOperation.defaultProps = defaultProps;
export default TransferOperation;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-transfer/src/operation.js